module.exports = __webpack_public_path__ + "static/media/UniNeueBook-Italic.e164c8ed.woff2";